import { render, staticRenderFns } from "./LobbyBanner.vue?vue&type=template&id=270da1b1&scoped=true&"
import script from "./LobbyBanner.vue?vue&type=script&lang=js&"
export * from "./LobbyBanner.vue?vue&type=script&lang=js&"
import style0 from "./LobbyBanner.vue?vue&type=style&index=0&id=270da1b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270da1b1",
  null
  
)

export default component.exports